import type {
  BulkImportFileDTO,
  BulkImportFilesListResponseDTO,
  BulkImportFilesResponse,
  BulkImportHistoryItem,
} from '../types/bulkImportsHistory.types';

const mapStatus = (
  status: BulkImportFileDTO['status']
): BulkImportHistoryItem['status'] => {
  if (status === 'FAILED') {
    return 'Rejected';
  } else if (status === 'PARTIAL_CREATED') {
    return 'Partial Reject';
  } else if (status === 'PROCESSING') {
    return 'Processing';
  }

  return 'Complete';
};

const isInProgress = (status: BulkImportFileDTO['status']): boolean =>
  status === 'IN_PROGRESS';

export const mapBulkImportFileDTO = (
  dto: BulkImportFileDTO
): BulkImportHistoryItem => {
  const normalizedStatus = mapStatus(dto.status);

  return {
    id: dto.id,
    fileName: dto.file_name,
    originalFileName: dto.original_file_name,
    uploadedBy: dto.uploaded_by,
    fileSizeBytes: dto.file_size_bytes,
    contentType: dto.content_type,
    checksumSha256: dto.checksum_sha256,
    uploadedAt: dto.created_at,
    updatedAt: dto.updated_at,
    totalRows: dto.total_rows,
    status: normalizedStatus,
    rawStatus: dto.status,
    createdRows: dto.valid_rows,
    failedRows: dto.invalid_rows,
    inProgress: isInProgress(dto.status),
    errorFilePresent: dto.error_file_present,
  };
};

export const mapBulkImportFilesResponse = (
  rawData: BulkImportFilesListResponseDTO
): BulkImportFilesResponse => {
  const results = rawData.data.map(item => mapBulkImportFileDTO(item));

  return {
    results,
    count: rawData.total_count,
    page: rawData.page,
    size: rawData.size,
  };
};
